<div style="margin-top: var(--spacing-spacing-5)" class="bordered-box">
  <p>{{ this.authorizeText }}</p>
</div>
